var map = {
	".": [
		17995,
		9
	],
	"./": [
		17995,
		9
	],
	"./DefaultLeaderbaord.scss": [
		91486,
		7,
		486
	],
	"./DefaultLeaderboard": [
		81537,
		9
	],
	"./DefaultLeaderboard.jsx": [
		81537,
		9
	],
	"./DefaultPodium": [
		74230,
		9
	],
	"./DefaultPodium.jsx": [
		74230,
		9
	],
	"./DynamicSprite": [
		87781,
		9
	],
	"./DynamicSprite.jsx": [
		87781,
		9
	],
	"./index": [
		17995,
		9
	],
	"./index.js": [
		17995,
		9
	],
	"./sprites/next_level/Halo": [
		35819,
		9,
		819
	],
	"./sprites/next_level/Halo.jsx": [
		35819,
		9,
		819
	],
	"./sprites/next_level/Halo.scss": [
		82196,
		7,
		196
	],
	"./sprites/spring_2025/Char0Var0": [
		39801,
		9,
		801
	],
	"./sprites/spring_2025/Char0Var0.jsx": [
		39801,
		9,
		801
	],
	"./sprites/spring_2025/Char0Var0.scss": [
		75030,
		7,
		30
	],
	"./sprites/spring_2025/Char0Var1": [
		89044,
		9,
		44
	],
	"./sprites/spring_2025/Char0Var1.jsx": [
		89044,
		9,
		44
	],
	"./sprites/spring_2025/Char0Var1.scss": [
		50757,
		7,
		757
	],
	"./sprites/spring_2025/Char0Var2": [
		86015,
		9,
		15
	],
	"./sprites/spring_2025/Char0Var2.jsx": [
		86015,
		9,
		15
	],
	"./sprites/spring_2025/Char0Var2.scss": [
		93088,
		7,
		88
	],
	"./sprites/spring_2025/Char1Var0": [
		42268,
		9,
		268
	],
	"./sprites/spring_2025/Char1Var0.jsx": [
		42268,
		9,
		268
	],
	"./sprites/spring_2025/Char1Var0.scss": [
		54269,
		7,
		269
	],
	"./sprites/spring_2025/Char1Var1": [
		21985,
		9,
		985
	],
	"./sprites/spring_2025/Char1Var1.jsx": [
		21985,
		9,
		985
	],
	"./sprites/spring_2025/Char1Var1.scss": [
		48814,
		7,
		814
	],
	"./sprites/spring_2025/Char1Var2": [
		73946,
		9,
		946
	],
	"./sprites/spring_2025/Char1Var2.jsx": [
		73946,
		9,
		946
	],
	"./sprites/spring_2025/Char1Var2.scss": [
		63687,
		7,
		687
	],
	"./sprites/summer_2025/KittyMonkeyBars": [
		13508,
		9,
		508
	],
	"./sprites/summer_2025/KittyMonkeyBars.jsx": [
		13508,
		9,
		508
	],
	"./sprites/summer_2025/KittyMonkeyBars.scss": [
		54077,
		7,
		77
	],
	"./sprites/summer_2025/KittyPotatoSackRace": [
		74097,
		9,
		97
	],
	"./sprites/summer_2025/KittyPotatoSackRace.jsx": [
		74097,
		9,
		97
	],
	"./sprites/summer_2025/KittyPotatoSackRace.scss": [
		91438,
		7,
		438
	],
	"./sprites/summer_2025/KittySlipNSlide": [
		14514,
		9,
		514
	],
	"./sprites/summer_2025/KittySlipNSlide.jsx": [
		14514,
		9,
		514
	],
	"./sprites/summer_2025/KittySlipNSlide.scss": [
		8575,
		7,
		575
	],
	"./sprites/summer_2025/PuppyMonkeyBars": [
		99567,
		9,
		567
	],
	"./sprites/summer_2025/PuppyMonkeyBars.jsx": [
		99567,
		9,
		567
	],
	"./sprites/summer_2025/PuppyMonkeyBars.scss": [
		78992,
		7,
		992
	],
	"./sprites/summer_2025/PuppyPotatoSackRace": [
		6838,
		9,
		838
	],
	"./sprites/summer_2025/PuppyPotatoSackRace.jsx": [
		6838,
		9,
		838
	],
	"./sprites/summer_2025/PuppyPotatoSackRace.scss": [
		47475,
		7,
		475
	],
	"./sprites/summer_2025/PuppySlipNSlide": [
		61901,
		9,
		901
	],
	"./sprites/summer_2025/PuppySlipNSlide.jsx": [
		61901,
		9,
		901
	],
	"./sprites/summer_2025/PuppySlipNSlide.scss": [
		26618,
		7,
		618
	],
	"./sprites/summer_2025/WheelbarrowRace": [
		42047,
		9,
		47
	],
	"./sprites/summer_2025/WheelbarrowRace.jsx": [
		42047,
		9,
		47
	],
	"./sprites/summer_2025/WheelbarrowRace.scss": [
		19152,
		7,
		152
	],
	"./sprites/treasure_island/KittyClimb": [
		15888,
		9,
		888
	],
	"./sprites/treasure_island/KittyClimb.jsx": [
		15888,
		9,
		888
	],
	"./sprites/treasure_island/KittyClimb.scss": [
		4102,
		7,
		721
	],
	"components/games/elements/GenericGame/DefaultLeaderboard": [
		17995,
		9
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/": [
		17995,
		9
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/DefaultLeaderbaord.scss": [
		91486,
		7,
		486
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/DefaultLeaderboard": [
		81537,
		9
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/DefaultLeaderboard.jsx": [
		81537,
		9
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/DefaultPodium": [
		74230,
		9
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/DefaultPodium.jsx": [
		74230,
		9
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/DynamicSprite": [
		87781,
		9
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/DynamicSprite.jsx": [
		87781,
		9
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/index": [
		17995,
		9
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/index.js": [
		17995,
		9
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/next_level/Halo": [
		35819,
		9,
		819
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/next_level/Halo.jsx": [
		35819,
		9,
		819
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/next_level/Halo.scss": [
		82196,
		7,
		196
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char0Var0": [
		39801,
		9,
		801
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char0Var0.jsx": [
		39801,
		9,
		801
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char0Var0.scss": [
		75030,
		7,
		30
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char0Var1": [
		89044,
		9,
		44
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char0Var1.jsx": [
		89044,
		9,
		44
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char0Var1.scss": [
		50757,
		7,
		757
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char0Var2": [
		86015,
		9,
		15
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char0Var2.jsx": [
		86015,
		9,
		15
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char0Var2.scss": [
		93088,
		7,
		88
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char1Var0": [
		42268,
		9,
		268
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char1Var0.jsx": [
		42268,
		9,
		268
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char1Var0.scss": [
		54269,
		7,
		269
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char1Var1": [
		21985,
		9,
		985
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char1Var1.jsx": [
		21985,
		9,
		985
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char1Var1.scss": [
		48814,
		7,
		814
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char1Var2": [
		73946,
		9,
		946
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char1Var2.jsx": [
		73946,
		9,
		946
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/spring_2025/Char1Var2.scss": [
		63687,
		7,
		687
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/KittyMonkeyBars": [
		13508,
		9,
		508
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/KittyMonkeyBars.jsx": [
		13508,
		9,
		508
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/KittyMonkeyBars.scss": [
		54077,
		7,
		77
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/KittyPotatoSackRace": [
		74097,
		9,
		97
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/KittyPotatoSackRace.jsx": [
		74097,
		9,
		97
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/KittyPotatoSackRace.scss": [
		91438,
		7,
		438
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/KittySlipNSlide": [
		14514,
		9,
		514
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/KittySlipNSlide.jsx": [
		14514,
		9,
		514
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/KittySlipNSlide.scss": [
		8575,
		7,
		575
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/PuppyMonkeyBars": [
		99567,
		9,
		567
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/PuppyMonkeyBars.jsx": [
		99567,
		9,
		567
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/PuppyMonkeyBars.scss": [
		78992,
		7,
		992
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/PuppyPotatoSackRace": [
		6838,
		9,
		838
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/PuppyPotatoSackRace.jsx": [
		6838,
		9,
		838
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/PuppyPotatoSackRace.scss": [
		47475,
		7,
		475
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/PuppySlipNSlide": [
		61901,
		9,
		901
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/PuppySlipNSlide.jsx": [
		61901,
		9,
		901
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/PuppySlipNSlide.scss": [
		26618,
		7,
		618
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/WheelbarrowRace": [
		42047,
		9,
		47
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/WheelbarrowRace.jsx": [
		42047,
		9,
		47
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/summer_2025/WheelbarrowRace.scss": [
		19152,
		7,
		152
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/treasure_island/KittyClimb": [
		15888,
		9,
		888
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/treasure_island/KittyClimb.jsx": [
		15888,
		9,
		888
	],
	"components/games/elements/GenericGame/DefaultLeaderboard/sprites/treasure_island/KittyClimb.scss": [
		4102,
		7,
		721
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 68411;
module.exports = webpackAsyncContext;